export type WorkspaceStateType = {
  collection: {
    data: Workspace[];
    error: null | string;
    loading: boolean; // start with loading state to avoid flash
  };
  member: {
    data: null | Workspace;
    error: null | string;
    loading: boolean; // start with loading state to avoid flash
    processing: boolean;
  };
};

export const WORKSPACE = 'workspace';
export type WORKSPACE = typeof WORKSPACE;

export const REQUEST_GET_WORKSPACES = `${WORKSPACE}/requestGetWorkspaces`;
export type REQUEST_GET_WORKSPACES = typeof REQUEST_GET_WORKSPACES;

export const REQUEST_SET_CURRENT_WORKSPACE = `${WORKSPACE}/requestSetCurrentWorkspaces`;
export type REQUEST_SET_CURRENT_WORKSPACE = typeof REQUEST_SET_CURRENT_WORKSPACE;
